module.exports = __webpack_public_path__ + "static/media/04cap_n.fc9a82db.svg";